/**
 * HelpdeskReportIssuePage v2 ReleaseAPI (under construction)
 */

import React, { useState, useRef } from 'react';

import { withStyles } from '@material-ui/core/styles';

// import @material-ui/core
import FormControl from '@material-ui/core/FormControl';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

// import react-router
import { Link, Prompt } from 'react-router-dom';

// import Formik and Dependency
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import * as Yup from 'yup';

// import globalStyles
import globalStyles from '../../../styles/globalStyles';

// import router and routers (routers constant)
import { routers } from './../../../routers';

// import utils (utils, HttpClient)
import { userProfiler, logger } from './../../../utils/utils';
import { useHandleClientError } from './../../../utils/HttpClient';

// import Fragments
// import FileGridList from './../../fragments/FileGridList';
import SelectPersonalDataCategory from './../../fragments/SelectPersonalDataCategory';
import DropFiles from './../../fragments/DropFiles';

import { issue, file } from './../../../data';
import { useIssueCreateId } from './../../../hooks/useData';

// Styles
const styles = (theme) => ({
  ...globalStyles(theme),
  root: {
    margin: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(1, 10, 1, 10),
    },
  },
  formControl: {
    margin: theme.spacing(1, 0),
  },
  formControlOutlined: {
    margin: theme.spacing(2, 0),
  },
  card: {
    minWidth: 275,
    padding: theme.spacing(2),
  },
  cardContent: {
    minHeight: 275,
  },
  cardAction: {
    justifyContent: 'flex-end',
    '& > *': {
      margin: theme.spacing(1, 3, 1, 1),
    },
  },
  section: {
    margin: theme.spacing(3, 0),
  },
});

// YUP: build validation schema (validationSchema)
const validationSchema = Yup.object().shape({
  category_id: Yup.string().required(
    'กรุณาเลือกประเภทของข้อมูลส่วนบุคคลที่มีการละเมิด'
  ),
  summary: Yup.string()
    .min(4, 'เรื่องโดยสรุปต้องมากกว่า 4 อักขระ')
    .max(255, 'เรื่องโดยสรุปต้องไม่เกิน 255 อักขระ')
    .required('กรุณากรอกเรื่องโดยสรุป'),
  description: Yup.string()
    .min(4, 'รายละเอียดต้องมากกว่า 4 อักขระ')
    .max(8000, 'รายละเอียดต้องไม่เกิน 8,000 อักขระ')
    .required('กรุณากรอกรายละเอียด'),
  contract: Yup.string()
    .min(4, 'ข้อมูลการติดต่อเพิ่มเติมต้องมากกว่า 4 อักขระ')
    .max(255, 'ข้อมูลการติดต่อเพิ่มเติมต้องไม่เกิน 255 อักขระ')
    .nullable(true),
});

const HelpdeskReportIssuePage = (props) => {
  // logger (Dev only)
  logger(`HelpdeskReportIssuePage render`);

  // Classes extend from widthStyle(style)
  const { classes, history } = props;

  // Get user profile
  const userProfile = userProfiler.getFromLocal();

  // Hook handle-client-error (handle error in catch from promise reject)
  const handleClientError = useHandleClientError();

  // routFrontOf is the front office router info.
  const routFrontOf = routers.frontOf;

  // const isSave
  const [isSave, setIsSave] = useState(false);

  // Hook createId
  const { id, shortId, createDate } = useIssueCreateId();
  // logger({id:, shortId, createDate });

  // InitialVaue of form reporting breach
  const initialValues = {
    id,
    shortId,
    category_id: '',
    fullname: userProfile.user.fullname,
    position: userProfile.user.position,
    keycode: userProfile.user.keycode,
    department: userProfile.user.department,
    summary: '',
    description: '',
    email: userProfile.user.email,
    contract: '',
    issueFiles: [],
  };
  const dropFilesRef = useRef();
  // Show from reporting breach
  const showFormReportBreach = ({
    values,
    setFieldValue,
    resetForm,
    touched,
    errors,
  }) => {
    return (
      <React.Fragment>
        <Form autoComplete="off">
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Typography component="div">
                <Box fontSize="h6.fontSize" fontWeight="bold" mb={1}>
                  แจ้งเหตุละเมิดข้อมูลส่วนบุคคล
                </Box>
                <Divider />
              </Typography>

              <Typography component="div" color="secondary">
                <Box
                  fontSize="ิfontSize"
                  fontWeight="bold"
                  mt={3}
                  mb={1}
                  color="secondary"
                >
                  * โปรดอย่าระบุข้อมูลส่วนบุคคลที่เกี่ยวข้องกับเหตุการณ์
                </Box>
                <Divider light />
              </Typography>
              <div className={`${classes.section}`}>
                <Typography component="div" gutterBottom>
                  <Box
                    fontSize="body1.fontSize"
                    fontWeight="bold"
                    mt={3}
                    mb={1}
                    color="secondary"
                  >
                    ข้อมูลผู้แจ้ง
                  </Box>
                </Typography>
                <FormControl
                  fullWidth
                  className={classes.formControl}
                  error={false}
                >
                  <Field
                    disabled
                    component={TextField}
                    name="fullname"
                    type="text"
                    label={'ชื่อผู้แจ้ง'}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  className={classes.formControl}
                  error={false}
                >
                  <Field
                    disabled
                    component={TextField}
                    name="department"
                    type="text"
                    label={'ส่วนงาน'}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  className={classes.formControl}
                  error={false}
                >
                  <Field
                    disabled
                    component={TextField}
                    name="position"
                    type="text"
                    label={'ตำแหน่ง'}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  className={classes.formControl}
                  error={false}
                >
                  <Field
                    disabled
                    component={TextField}
                    name="email"
                    type="text"
                    label={'อีเมล '}
                  />
                </FormControl>
                <Typography component="div" gutterBottom>
                  <Box
                    fontSize="body1.fontSize"
                    fontWeight="bold"
                    mt={3}
                    mb={1}
                    color="secondary"
                  >
                    แจ้งเหตุละเมิด
                  </Box>
                </Typography>
                <div className={classes.formStyle}>
                  <SelectPersonalDataCategory
                    name="category_id"
                    size="small"
                    variant="outlined"
                  />
                  <FormControl fullWidth error={false}>
                    <Field
                      component={TextField}
                      name="summary"
                      type="text"
                      label={'เรื่องโดยสรุป *'}
                      size="small"
                      variant="outlined"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <Field
                      component={TextField}
                      name="description"
                      multiline
                      rowsMax={6}
                      rows={6}
                      label="รายละเอียด *"
                      size="small"
                      variant="outlined"
                    />
                  </FormControl>

                  <FormControl fullWidth error={false}>
                    <Field
                      component={TextField}
                      name="contract"
                      multiline
                      rowsMax={3}
                      rows={3}
                      label={'ข้อมูลการติดต่อเพิ่มเติม'}
                      size="small"
                      variant="outlined"
                    />
                  </FormControl>
                  <DropFiles
                    ref={dropFilesRef}
                    onDropped={async (newFiles, extendNewFiles) => {
                      
                      // Save file (file.save, request api image/vx/save) and get filesSaved
                      let filesSaved = await file.save({
                        data: newFiles.map((file) => ({
                          issue_id: id,
                          name: file.name,
                          type: file.type,
                          content: file.base64,
                        })),
                      });


                      // Callback (use extendNewFiles), Add file id (from filesSaved, field: id) to files (each nfile)
                      await extendNewFiles((nfile) => {
                        let fileSaved = filesSaved.find(
                          (fs) => fs.name === nfile.name
                        );
                        if (fileSaved !== undefined) {
                          return { id: fileSaved.id };
                        }
                        return { id: 'n/a' };
                      });
                    }}
                  />
                </div>
              </div>
              <Divider />
            </CardContent>
            <CardActions className={classes.cardAction}>
              <Button variant="contained" color="primary" type="submit">
                ส่ง
              </Button>
              <Button
                component={Link}
                to={routFrontOf.reportIssue.path}
                color="default"
                variant="contained"
                onClick={(e) => {
                  e.preventDefault();
                  resetForm();
                }}
              >
                ยกเลิก
              </Button>
            </CardActions>
          </Card>
        </Form>
        <Prompt
          when={
            !isSave && JSON.stringify(initialValues) !== JSON.stringify(values)
          }
          message="การเปลี่ยนแปลงข้อมูลจะไม่ถูกบันทึก"
        />
      </React.Fragment>
    );
  };

  return (
    <div className={classes.root}>
      <Formik
        validationSchema={validationSchema}
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);
          let reqIssue = {
            id,
            shortId,
            category_id: values.category_id,
            fullname: values.fullname,
            position: values.position,
            department: values.department,
            keycode: values.keycode,
            email: values.email,
            summary: values.summary,
            description: values.description,
            contract: values.contract,
            // // Personal/System information
            // createBy: values.createBy,
            issueFiles: dropFilesRef.current.files
              .map((file) => file.id)
              .join(','),
          };

          // logger(reqIssue);
          setIsSave(true);
          // POST Request addIssue
          issue
            .addIssue({ issue: reqIssue })
            .then((result) => {
              history.push(routers.frontOf.issues.path);
            })
            .catch((error) => handleClientError(error));
        }}
      >
        {(props) => showFormReportBreach(props)}
      </Formik>
    </div>
  );
};

export default withStyles(styles)(HelpdeskReportIssuePage);
